import { combineReducers } from 'redux';
import { errorsReducer as errors } from 'iqvia-shared';
import { reducer as formReducer } from 'redux-form';

import journeyBuilderArea from '../../JourneyBuilder/reducers';

export default combineReducers({
  form: formReducer.plugin({}),
  errors,
  journeyBuilderArea,
});



// WEBPACK FOOTER //
// ./src/Root/reducers/index.js